// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-hero-awkward-hero-bg-image----hero-bg-image-module---wrapper---60t_r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/hero-awkward/hero-bg-image/hero-bg-image.module.css
// module id = 86
// module chunks = 87641678943312 148102121165778 262425733011174